export const INPUT_NAMES = {
  NEW_PASS: 'newPass',
  REPEAT_PASS: 'repeatPass',
};
